import { render } from "./CustomizeEmailTab.vue?vue&type=template&id=ca5e1e40&scoped=true"
import script from "./CustomizeEmailTab.vue?vue&type=script&lang=js"
export * from "./CustomizeEmailTab.vue?vue&type=script&lang=js"

import "./CustomizeEmailTab.vue?vue&type=style&index=0&id=ca5e1e40&lang=scss&scoped=true"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca5e1e40"]])

export default __exports__